import { createContext, useContext } from "react";

/** Message rendering style. Extend this union to add new view modes. */
export type MessageViewMode = "chat" | "prose";

/** Metadata for each available view mode (labels, icons for UI switching). */
export interface MessageViewModeMeta {
  key: MessageViewMode;
  label: string;
  description: string;
}

export const MESSAGE_VIEW_MODES: MessageViewModeMeta[] = [
  { key: "chat", label: "Chat", description: "Classic chat bubbles — narrator and player messages as separate cards." },
  { key: "prose", label: "Prose", description: "Immersive story-first reading — narrator text flows as paragraphs, player actions as compact annotations." },
];

// ── Context ──

const MessageViewModeContext = createContext<MessageViewMode>("chat");

export function MessageViewModeProvider({
  mode,
  children,
}: {
  mode: MessageViewMode;
  children: React.ReactNode;
}) {
  return (
    <MessageViewModeContext.Provider value={mode}>
      {children}
    </MessageViewModeContext.Provider>
  );
}

export function useMessageViewMode(): MessageViewMode {
  return useContext(MessageViewModeContext);
}
